import { useUpgradeInitialPath } from "./hooks/useUpgradeInitialPath";
import {
  UpgradeFlowShellContextProvider,
  type UpgradeFlowProps,
} from "./UpgradeFlowContext";
import { UpgradePlanRouter } from "./UpgradePlanRouter";

export const UpgradeFlow = (props: UpgradeFlowProps) => {
  const initialPath = useUpgradeInitialPath();

  return (
    <UpgradeFlowShellContextProvider value={props}>
      <UpgradePlanRouter initialPath={initialPath} />
    </UpgradeFlowShellContextProvider>
  );
};
